import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { FaCar } from "react-icons/fa";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-bg-circle circle-one"></div>
      <div className="not-found-bg-circle circle-two"></div>

      <div className="not-found-content">
        <div className="not-found-number">
          4<span>0</span>4
        </div>

        <div className="not-found-icon">
        <FaCar color="rgb(44, 144, 141)"/>
        </div>

        <h1 className="brandTitle">Page Not Found</h1>

        <p>
          Sorry, the page you are looking for doesn't exist,
          has been moved, or is temporarily unavailable.
        </p>

        <div className="not-found-actions">
          

          <button
            type="button"
            className="btn text-white px-5 py-2"
            style={{
              backgroundColor: "#2C908D",
              borderColor: "#2C908D",
              fontWeight: "600",
              boxShadow: "none",
              outline: "none",
            }}
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />&nbsp;
            Go Back
          </button>
        </div>

        <div className="not-found-footer">
          Error Code: <strong>404</strong>
        </div>
      </div>
    </div>
  );
}
